<template>
  <dl>
    <dt>
      {{optionItem.menuOptionName}}
      <span class='requTxt point1' :class='{point: mandatoryOption}'>
        {{mandatoryOption ? $t('required') : $t('optional') +  $t('Detail.maximum1')}}
      </span>
    </dt>
    <!-- 세부옵션-->
    <dd>
      <ul class='ul'>
        <li v-for='(detailOption, index) in optionItem.detailOption' :key='detailOption.menuDetailOptionCode'>
          <label class='label'>
            <input
              :type='mandatoryOption?"radio":"checkbox"'
              :class='mandatoryOption?"rdo":"chk"'
              :name='optionItem.menuOptionCode'
              :disabled ="detailOption.soldOutFlag == 1"
              :checked='checkedIndex === index'
              @click='addDetailOption($event, detailOption, index)'/>
            <span class='ico'></span>
            <span class='lTxt'>{{detailOption.menuDetailOptionName}}</span>
          </label>
          <div class="soldout" v-if="detailOption.soldOutFlag">({{$t('soldOut')}})</div>
          <div class='txt' v-else> + {{formatComma(detailOption.price)}}{{$t('MoneyUnit')}}</div>
        </li>
      </ul>
    </dd>
  </dl>
</template>
<script lang="js">
import { MANDATORY_OPTION_FLAG } from '@/utils/Code'
import { NORMAL_OPTION } from '@/utils/EndPoint'
import { ABLE_CHOOSE_ONLY_ONE_OPTION_MSG } from '@/utils/Message'
import Vue from 'vue'
export default Vue.extend({
  name: NORMAL_OPTION,
  props: ['optionItem', 'options', 'price'],
  data () {
    return {
      mandatoryOption: this.optionItem.mandatoryFlag === MANDATORY_OPTION_FLAG,
      checkedIndex: -1 // 선택된 옵션 index 번호
    }
  },
  created () {
    setTimeout(() => {
    // 만약 필수옵션이라면 첫번째 상세 옵션 push
      if (this.mandatoryOption && this.optionItem.detailOption[0].soldOutFlag == 0) {
        this.checkedIndex = 0
        this.$emit('update:price', this.price + this.optionItem.detailOption[0].price)
        this.options[this.optionItem.menuOptionCode] = { ...this.optionItem, detailOption: this.optionItem.detailOption[0] }
      }
    }, 0)
  },
  methods: {
    addDetailOption (event, detailOption, index) {
      if (this.checkedIndex < 0) {
        // 처음 선택 옵션 선택
        this.options[this.optionItem.menuOptionCode] = { ...this.optionItem, detailOption: detailOption }
        this.$emit('update:price', this.price + detailOption.price)
        this.checkedIndex = index
        return
      }

      const preOption = this.optionItem.detailOption[this.checkedIndex]
      if (this.mandatoryOption) { // 필수옵션인 경우
        const newPrice = this.price - preOption.price
        this.options[this.optionItem.menuOptionCode].detailOption = detailOption
        this.$emit('update:price', newPrice + detailOption.price)
        this.checkedIndex = index
      } else { // 선택 옵션인 경우
        // 같은 옵션 click
        if (preOption.menuDetailOptionCode === detailOption.menuDetailOptionCode) {
          this.checkedIndex = -1
          this.$emit('update:price', this.price - detailOption.price)
          delete this.options[this.optionItem.menuOptionCode]
        } else { // 다른 옵션인 경우
          event.target.checked = false
          this.toast(this, ABLE_CHOOSE_ONLY_ONE_OPTION_MSG)
        }
      }
    }
  }
})
</script>
